<template>
  <va-create-layout>
    <state-form :title="title" :item="item"></state-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
